import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Box } from '@mui/material';

export default function TooltipTableHeader({
    title = '',
    placement = 'top'
}) {
    return (
        <Tooltip
            title={<Box>{title}</Box>}
            slotProps={{
                popper: {
                    modifiers: [{
                        name: 'offset',
                        options: {
                            offset: [0, -4]
                        }
                    }]
                }
            }}
            placement={placement}
            disableInteractive
        >
            <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {title}
            </Box>
        </Tooltip>
    )
}